// @ts-expect-error
import capitalize from 'underscore.string/capitalize';

import {api} from 'nutshell-core/api';
import type {CoreEntityType} from 'nutshell-core/types';

// This tells redux-select how to populate a list of select options asyncronously.
export function fetchOptions(collections: CoreEntityType | 'users'[]) {
    return (query: string) => {
        return (
            api
                .get('searchresults', {
                    // @ts-expect-error
                    filter: {entityType: collections.map(capitalize)},
                    q: query,
                })
                // @ts-expect-error
                .then((response) => response.json())
                .then((json: {searchResults: any[] | null | undefined}) => {
                    if (!json.searchResults) return;

                    return json.searchResults.map((item: any) => {
                        // Only return the keys that we need for now.
                        return {
                            avatarUrl: item.avatarUrl,
                            name: item.displayName,
                            id: item.links.entity.id,
                            initials: item.initials,
                            type: item.links.entity.type,
                            primaryInfo: item.primaryInfo,
                            relatedName: item.relatedName, // Holds user's email address (for some reason)
                            // Useful for passing around additional data with the
                            // option that isn't necessarily used in our
                            // graphql-select components
                            metaData: {
                                href: item.htmlUrlPath,
                            },
                        };
                    });
                })
        );
    };
}
